import { $, merge } from "glamor";
import theme from "styles/theme";

export const pasteContainerStyles = () =>
    merge(
        $(".container", {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            padding: "8px",
            height: "100%",
        }),
        $(" .descriptionText", {
            padding: "8px",
        }),
        $(" .exportContainer", {
            display: "flex",
            flexDirection: "row",
            justifyContent: "right",
            width: "100%",
        }),
        $(" .exportButton", {
            border: "none",
            backgroundColor: "transparent",
            color: theme.palette.lightBlue,
        }),
        $(" .exportButton:hover", {
            border: "none",
            backgroundColor: "transparent",
            color: theme.palette.blueHover,
        }),
        $(" .tableTabContainer", {
            display: "flex",
            flexDirection: "row",
            flex: 1,
            marginTop: "16px",
        }),
        $(" .targetListContainer", {
            width: "200px",
            borderRight: `1px solid ${theme.palette.lightGrey}`,
        }),
        $(" .targetValueGrid", {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            marginLeft: "24px",
            minHeight: "400px",
        }),
        $(" .targetValueGridErrorContainer", {
            display: "flex",
            flexDirection: "row",
            padding: "12px 16px",
            border: `1px solid ${theme.palette.errorAlertBorderColor}`,
            borderRadius: "4px",
            alignItems: "center",
            justifyContent: "start",
            color: theme.palette.errorColor,
            backgroundColor: theme.palette.errorLightBackground,
            marginBottom: "15px",
        })
    );

export const targetFilterRowStyles = () =>
    merge(
        $(".container", {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            padding: "4px",
            height: "60px",
            borderTop: `1px solid ${theme.palette.lightGrey}`,
            borderLeft: `1px solid ${theme.palette.lightGrey}`,
            borderRight: `1px solid ${theme.palette.lightGrey}`,
            marginRight: "-1px",
            backgroundColor: theme.palette.lightestGrey,
            position: "relative",
            borderBottom: "none",
        }),
        $(".selectedContainer", {
            borderLeft: "2px solid #00A9A4",
            borderRight: "1px solid white !important",
            backgroundColor: "white",
            zIndex: 1,
            boxShadow: "-1px 1px 2px 0px rgba(0, 0, 0, 0.15)",
        }),
        $(".containerError", {
            borderLeft: `3px solid ${theme.palette.errorColor}`,
            borderRight: "1px solid white !important",
            color: theme.palette.errorColor,
            backgroundColor: "white",
            zIndex: 1,
            boxShadow: "rgba(0, 0, 0, 0.15) 0px 1.95px 2.6px",
        }),
        $(".container:last-child", {
            borderBottom: `1px solid ${theme.palette.lightGrey}`,
        }),
        $(" .mainText", {
            fontWeight: "bold",
        }),
        $(".selectedContainer > .targetFilterDescriptionText", {
            color: theme.palette.black,
            fontSize: "1rem",
        }),
        $(" .targetFilterDescriptionText", {
            color: theme.palette.grey,
            fontSize: "1rem",
        }),
        $(" .targetFilterDescriptionErrorText", {
            color: theme.palette.errorColor,
            fontSize: "1rem",
        }),
        $(" .statusContainer", {
            position: "absolute",
            top: "50%",
            right: "4px",
            marginTop: "-6px",
        }),
        $(" .totalText", {
            fontSize: "1rem",
        })
    );

export const targetValuesGridStyles = () =>
    merge(
        $(".targetValueContainer", {
            display: "flex",
            flexDirection: "column",
            height: "100%",
        }),
        $(" .totalContainer", {
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            alignItems: "center",
            height: "50px",
            fontWeight: "bold",
        }),
        $(" .grid", {
            flex: 1,
            margin: "0",
        }),
        $(" .ag-theme-balham .doorsGroupTotal--notEditable", {
            backgroundColor: theme.grid.headerBackgroundColor,
            color: "#a5a0a0",
        }),
        $(" .ag-theme-balham .errorTargetValue", {
            backgroundColor: theme.palette.errorLightBackground,
        })
    );
